import { Navigate, useLocation } from 'react-router-dom'
import DashboardLayout from '../pages/DashboardLayout'
import { getSavedAuthData } from '../api/axios/interceptor'
import PlanSelectionGuard from '../components/guards/PlanSelectionGuard'

export const ProtectedRouts = () => {
  const { accessToken } = getSavedAuthData()
  const location = useLocation()

  if (accessToken) {
    return (
      <PlanSelectionGuard>
        <DashboardLayout />
      </PlanSelectionGuard>
    )
  }
  // Remember where the user was headed (e.g. a case link from a reminder email)
  // so login can bring them back there instead of dropping them on /home.
  const redirect = encodeURIComponent(location.pathname + location.search)
  return <Navigate to={`/login?redirect=${redirect}`} replace />
}
